<div class="modal-content">
    <div class="modal-header">
        <img src="../../../assets/icon/alerta.svg" alt="" class="me-2">
        <h3 class="fzas-modal-title m-0">{{ titulo }}</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"(click)="salir(false)"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <p class="fzas-modal-text">{{ texto }}</p>
                <div class="json-container">
    <pre>{{ data | json }}</pre>
</div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-12 d-flex justify-content-end gap-3">
                <button type="button" class="btn btn-aplicar-accion" (click)="salir(true)">Cerrar</button>
            </div>
        </div>
    </div>
</div>